<template>
  <div class="page-recycle-detail">
    <el-descriptions class="margin-top" title="回收订单详情" :column="2" border>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-document"></i>
          主键ID
        </template>
        {{ recycleInfo.id || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          用户ID
        </template>
        {{ recycleInfo.userId || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          用户姓名
        </template>
        {{ recycleInfo.userName || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-mobile-phone"></i>
          用户手机号
        </template>
        {{ recycleInfo.userPhone || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-location-outline"></i>
          回收地址
        </template>
        {{ recycleInfo.userAddress || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-flag"></i>
          回收状态
        </template>
        {{ statusMap[recycleInfo.status] || recycleInfo.status || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-collection"></i>
          回收类型
        </template>
        {{ typeMap[recycleInfo.type] || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          预约时间
        </template>
        {{ recycleInfo.appointmentTime || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          创建时间
        </template>
        {{ recycleInfo.createdAt || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          更新时间
        </template>
        {{ recycleInfo.updatedAt || "-" }}
      </el-descriptions-item>
    </el-descriptions>

    <!-- 手机回收详细信息 -->
    <el-descriptions
      v-if="recycleInfo.type == 0"
      class="margin-top mt-20"
      title="手机回收详细信息"
      :column="2"
      border
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-mobile"></i>
          手机品牌
        </template>
        {{ recycleInfo.brand || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-mobile"></i>
          手机型号
        </template>
        {{ recycleInfo.model || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-info"></i>
          存储容量
        </template>
        {{ recycleInfo.storageCapacity || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-info"></i>
          内存容量
        </template>
        {{ recycleInfo.ramCapacity || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-brush"></i>
          颜色
        </template>
        {{ recycleInfo.color || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-star-on"></i>
          成色等级
        </template>
        {{ recycleInfo.conditionLevel || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-info"></i>
          版本
        </template>
        {{ recycleInfo.version || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-date"></i>
          购买日期
        </template>
        {{ recycleInfo.purchaseDate || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-check"></i>
          是否有原装盒
        </template>
        {{ recycleInfo.hasOriginalBox == 1 ? "有" : "无" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-check"></i>
          是否有原装充电器
        </template>
        {{ recycleInfo.hasOriginalCharger == 1 ? "有" : "无" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-check"></i>
          是否有发票
        </template>
        {{ recycleInfo.hasInvoice == 1 ? "有" : "无" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-monitor"></i>
          屏幕状况
        </template>
        {{ recycleInfo.screenCondition || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-data-line"></i>
          电池健康度(百分比)
        </template>
        {{ recycleInfo.batteryHealth || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-info"></i>
          IMEI号
        </template>
        {{ recycleInfo.imei || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-warning"></i>
          功能问题描述
        </template>
        {{ recycleInfo.functionalIssues || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-warning"></i>
          外观问题描述
        </template>
        {{ recycleInfo.cosmeticIssues || "-" }}
      </el-descriptions-item>
    </el-descriptions>

    <!-- 衣物回收详细信息 -->
    <el-descriptions
      v-if="recycleInfo.type == 1"
      class="margin-top mt-20"
      title="衣物回收详细信息"
      :column="2"
      border
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-data-analysis"></i>
          预估最小重量
        </template>
        {{ recycleInfo.estimatedWeightMin || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-data-analysis"></i>
          预估最大重量
        </template>
        {{ recycleInfo.estimatedWeightMax || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-data-analysis"></i>
          实际重量
        </template>
        {{ recycleInfo.realWeight || "-" }}
      </el-descriptions-item>
    </el-descriptions>

    <!-- 价格信息 -->
    <el-descriptions
      class="margin-top mt-20"
      title="价格信息"
      :column="2"
      border
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-coin"></i>
          预估回收价格
        </template>
        {{ recycleInfo.estimatedPrice || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-coin"></i>
          实际回收价格
        </template>
        {{ recycleInfo.actualPrice || "-" }}
      </el-descriptions-item>
    </el-descriptions>

    <!-- 回收图片 -->
    <el-descriptions
      class="margin-top mt-20"
      title="回收图片"
      :column="1"
      border
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-picture"></i>
          图片
        </template>
        <div class="image-list" v-if="imageList.length > 0">
          <el-popover
            placement="right"
            trigger="hover"
            width="300"
            v-for="(img, index) in imageList"
            :key="index"
          >
            <img :src="img" width="280" />
            <img
              slot="reference"
              :src="img"
              style="height: 80px; width: 80px; margin-right: 10px"
            />
          </el-popover>
        </div>
        <span v-else>-</span>
      </el-descriptions-item>
    </el-descriptions>

    <!-- 物流信息 -->
    <el-descriptions
      class="margin-top mt-20"
      title="物流信息"
      :column="2"
      border
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          实际回收时间
        </template>
        {{ recycleInfo.actualTime || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          实际退还时间
        </template>
        {{ recycleInfo.actualReturnTime || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-order"></i>
          回收快递单号
        </template>
        {{ recycleInfo.trackingNum || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-order"></i>
          退还快递单号
        </template>
        {{ recycleInfo.trackingReturnNum || "-" }}
      </el-descriptions-item>
    </el-descriptions>

    <div class="btn-content">
      <el-button
        v-if="recycleInfo.status === 'pending'"
        type="primary"
        size="small"
        @click="openUpdateDialog('pending')"
        >填写预估价格</el-button
      >
      <el-button
        v-if="recycleInfo.status === 'assessed' && !recycleInfo.actualPrice"
        type="primary"
        size="small"
        @click="openUpdateDialog('assessed')"
        >填写实际价格</el-button
      >
      <el-button
        v-if="recycleInfo.status === 'applyreturn'"
        type="primary"
        size="small"
        @click="showReturnDialog = true"
        >退货</el-button
      >
      <el-button type="primary" size="small" @click="goBack">返回</el-button>
    </div>

    <!-- 更新状态弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showUpdateDialog"
      width="500px"
    >
      <el-form
        :model="updateForm"
        ref="updateForm"
        :rules="currentRules"
        label-width="120px"
      >
        <el-form-item
          v-if="currentStatus === 'pending'"
          label="预估回收价格"
          prop="estimatedPrice"
        >
          <el-input
            v-model="updateForm.estimatedPrice"
            placeholder="请输入预估回收价格"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="currentStatus === 'assessed'"
          label="实际价格"
          prop="actualPrice"
        >
          <el-input
            v-model="updateForm.actualPrice"
            placeholder="请输入实际价格"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="currentStatus === 'assessed' && recycleInfo.type == 1"
          label="实际重量"
          prop="realWeight"
        >
          <el-input
            v-model="updateForm.realWeight"
            placeholder="请输入实际重量"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="currentStatus === 'pending'"
          label="回收快递单号"
          prop="trackingNum"
        >
          <el-input
            v-model="updateForm.trackingNum"
            placeholder="请输入回收快递单号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeUpdateDialog">取 消</el-button>
        <el-button type="primary" @click="handleUpdateRecycle">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 退货弹窗 -->
    <el-dialog title="退货" :visible.sync="showReturnDialog" width="500px">
      <el-form
        :model="returnForm"
        ref="returnForm"
        :rules="returnRules"
        label-width="120px"
      >
        <el-form-item label="退货订单号" prop="trackingReturnNum">
          <el-input
            v-model="returnForm.trackingReturnNum"
            placeholder="请输入退货订单号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showReturnDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleReturn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      recycleInfo: {},
      imageList: [],
      showUpdateDialog: false,
      showReturnDialog: false,
      currentStatus: "", // 当前操作的状态
      updateForm: {
        estimatedPrice: "",
        actualPrice: "",
        realWeight: "",
        trackingNum: "",
      },
      updateRules: {
        estimatedPrice: [
          { required: true, message: "请输入预估回收价格", trigger: "blur" },
        ],
        actualPrice: [
          { required: true, message: "请输入实际价格", trigger: "blur" },
        ],
        realWeight: [
          { required: true, message: "请输入实际重量", trigger: "blur" },
        ],
        trackingNum: [
          { required: true, message: "请输入回收快递单号", trigger: "blur" },
        ],
      },
      returnForm: {
        trackingReturnNum: "",
      },
      returnRules: {
        trackingReturnNum: [
          { required: true, message: "请输入退货订单号", trigger: "blur" },
        ],
      },
      statusMap: {
        pending: "已预约",
        assessed: "回收中",
        completed: "已完成",
        applyreturn: "申请退回",
        rejected: "已退回",
      },
      typeMap: {
        0: "手机",
        1: "衣物",
      },
    };
  },
  computed: {
    dialogTitle() {
      const titleMap = {
        pending: "填写预估价格",
        assessed: "填写实际价格",
      };
      return titleMap[this.currentStatus] || "更新回收订单";
    },
    currentRules() {
      const rules = {};
      if (this.currentStatus === "pending") {
        rules.estimatedPrice = this.updateRules.estimatedPrice;
        rules.trackingNum = this.updateRules.trackingNum;
      } else if (this.currentStatus === "assessed") {
        rules.actualPrice = this.updateRules.actualPrice;
        // 如果是衣物类型，需要验证实际重量
        if (this.recycleInfo.type == 1) {
          rules.realWeight = this.updateRules.realWeight;
        }
      }
      return rules;
    },
  },
  created() {
    this.id = this.$route.query.id || "";
    this.getRecycleInfo();
  },
  methods: {
    openUpdateDialog(status) {
      this.currentStatus = status;
      // 重置表单
      this.updateForm = {
        estimatedPrice: "",
        actualPrice: "",
        realWeight: "",
        trackingNum: "",
      };
      if (this.$refs.updateForm) {
        this.$refs.updateForm.resetFields();
      }
      this.showUpdateDialog = true;
    },
    closeUpdateDialog() {
      this.showUpdateDialog = false;
      this.currentStatus = "";
      this.updateForm = {
        estimatedPrice: "",
        actualPrice: "",
        realWeight: "",
        trackingNum: "",
      };
      if (this.$refs.updateForm) {
        this.$refs.updateForm.resetFields();
      }
    },
    async getRecycleInfo() {
      let res = await this.$post("/recycle/recycleDetails", { id: this.id });
      this.recycleInfo = res || {};
      // 处理图片字段
      if (this.recycleInfo.images) {
        try {
          this.imageList = this.recycleInfo.images.split(",");
        } catch (e) {
          this.imageList = [];
        }
      }
    },
    // 更新回收订单状态
    handleUpdateRecycle() {
      this.$refs.updateForm.validate(async (valid) => {
        if (valid) {
          try {
            const payload = { id: this.id };

            // 根据状态构建不同的请求参数
            if (this.currentStatus === "pending") {
              payload.estimatedPrice = this.updateForm.estimatedPrice;
              payload.trackingNum = this.updateForm.trackingNum;
              payload.status = "assessed"; // 填写预估价格后，状态变为回收中
            } else if (this.currentStatus === "assessed") {
              payload.actualPrice = this.updateForm.actualPrice;
              // 如果是衣物类型，需要传递实际重量
              if (this.recycleInfo.type == 1) {
                payload.realWeight = this.updateForm.realWeight;
                payload.status = "completed"; // 衣物回收填写实际重量和实际价格后，状态变为已完成
              }
              // 非衣物类型，填写实际价格后，状态不变
            }

            const res = await this.$http.post(
              "/recycle/updateRecycle",
              payload,
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            if (res.status === 200) {
              this.$message.success("操作成功");
              this.closeUpdateDialog();
              // 重新获取详情
              this.getRecycleInfo();
            } else {
              this.$message.error(res.data.message || "操作失败");
            }
          } catch (error) {
            this.$message.error("操作失败");
          }
        }
      });
    },
    // 处理退货
    handleReturn() {
      this.$refs.returnForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await this.$http.post(
              "/recycle/updateRecycle",
              {
                id: this.id,
                trackingReturnNum: this.returnForm.trackingReturnNum,
                status: "rejected",
              },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            if (res.status === 200) {
              this.$message.success("退货成功");
              this.showReturnDialog = false;
              // 重新获取详情
              this.getRecycleInfo();
              // 重置表单
              this.$refs.returnForm.resetFields();
            } else {
              this.$message.error(res.data.message || "退货失败");
            }
          } catch (error) {
            this.$message.error("退货失败");
          }
        }
      });
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import './../../styl/variables.styl'
@import './../../styl/common.styl'
.mt-20 {
  margin-top: 20px
}
.page-recycle-detail {
  padding: 20px
}
.btn-content {
  display flex
  justify-content center
  margin-top 20px
}
.image-list {
  display flex
  flex-wrap wrap
}
</style>
